"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _lodash = _interopRequireDefault(require("lodash.isequal"));

function getContext(_ref) {
  var state = _ref.state,
      actions = _ref.actions;
  return {
    state: state,
    actions: actions
  };
}

function contextHasChanges(_ref2, _ref3) {
  var _ref4 = (0, _slicedToArray2["default"])(_ref2, 1),
      newArgs = _ref4[0],
      _ref5 = (0, _slicedToArray2["default"])(_ref3, 1),
      oldArgs = _ref5[0];

  return (0, _lodash["default"])(getContext(newArgs), getContext(oldArgs));
}

var _default = (0, _memoizeOne["default"])(getContext, contextHasChanges);

exports["default"] = _default;